import { JsonObject, JsonProperty } from 'json2typescript';
import { Param } from './params-model';

@JsonObject('FileType')
export class FileType {
  @JsonProperty('code', String, true) code: string = undefined;
  @JsonProperty('type', String, true) type: string = undefined;
  @JsonProperty('params', [Param], true) params: Param[] = undefined;
}
